import React, { PropsWithChildren } from 'react';
import { Modal, useBreakpoint } from '@landr/maestro';
import { css } from '@landr/styled-system/css';

export const wrapper = css({
    padding: {
        base: 'sm',
        md: '2xl',
    },
    overflow: 'hidden',
    position: 'relative',
    width: {
        base: '50%',
        md: '100%',
    },
    flex: '0 0 50%',
    background: 'surface.inverted',
});

export const styledContent = css({
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'center',
    position: 'relative',
    textAlign: 'center',
    width: '100%',
    zIndex: 1,
    borderLeftRadius: 'modal',
});

const DescriptiveSection: React.FC<PropsWithChildren> = ({ children }) => {
    const isMobile = useBreakpoint('md');

    if (isMobile) {
        return null;
    }

    return (
        <Modal.Section className={wrapper}>
            <div className={styledContent}>{children}</div>
        </Modal.Section>
    );
};

export default DescriptiveSection;
